import React from 'react'

export interface ProductQualityBadgeProps {
  quality: 'good' | 'incomplete' | 'poor'
  className?: string
}

// Quality configuration mapping
const qualityConfig = {
  good: {
    bgClass: 'tw-bg-green-100',
    textClass: 'tw-text-green-800',
    dotClass: 'tw-bg-green-500',
    text: 'Good'
  },
  incomplete: {
    bgClass: 'tw-bg-orange-100',
    textClass: 'tw-text-orange-800', 
    dotClass: 'tw-bg-orange-500',
    text: 'Incomplete'
  },
  poor: {
    bgClass: 'tw-bg-red-100',
    textClass: 'tw-text-red-800',
    dotClass: 'tw-bg-red-500',
    text: 'Poor'
  }
}

function ProductQualityBadge({
  quality,
  className = ''
}: ProductQualityBadgeProps) {
  const config = qualityConfig[quality]
  
  return (
    <span 
      className={`tw-inline-flex tw-items-center tw-rounded-full ${config.bgClass} tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-medium ${config.textClass} tw-gap-1.5 ${className}`}
      role="status"
      aria-label={`Product quality: ${config.text}`}
    >
      <span className={`tw-size-2 tw-rounded-full ${config.dotClass}`}></span>
      {config.text}
    </span>
  )
}

export default ProductQualityBadge